import { render } from "./roles-permissions.vue?vue&type=template&id=454ac634&scoped=true"
import script from "./roles-permissions.vue?vue&type=script&lang=js"
export * from "./roles-permissions.vue?vue&type=script&lang=js"

import "./roles-permissions.vue?vue&type=style&index=0&id=454ac634&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454ac634"]])

export default __exports__